import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import DayBookPage from "./pages/DayBookPage";
import ContactsPage from "./pages/ContactsPage";
import InventoryPage from "./pages/InventoryPage";
import ChatPage from "./pages/ChatPage";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import AdminPage from "./pages/AdminPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import ConversationLogPage from "./pages/ConversationLogPage";

const Loader = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="flex items-center gap-0.5">
      <span className="text-2xl font-bold tracking-[-0.04em] text-white animate-pulse">NOTE</span>
      <span className="text-2xl font-bold tracking-[-0.04em] animate-pulse"
        style={{ background: 'linear-gradient(135deg, #FF2D55, #5856D6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>HO</span>
    </div>
  </div>
);

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
};

const PublicRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Landing page — always accessible */}
          <Route path="/" element={<LandingPage />} />

          {/* Public routes */}
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/daybook" element={<DayBookPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/analytics" element={<AdminPage />} />
            <Route path="/live-log" element={<ConversationLogPage />} />
          </Route>

          {/* Admin Dashboard — own password auth, no Supabase login required */}
          <Route path="/admin" element={<AdminDashboardPage />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
      <Toaster position="bottom-center" richColors />
    </BrowserRouter>
  );
}

export default App;
